<dt role="heading" aria-level="3">
  <button
    class="accordion__heading"
    [ngClass]="[filled ? 'accordion__heading--filled' : '', skinny ? 'accordion__heading--skinny' : '']"
    [attr.aria-expanded]="selected"
    [attr.aria-controls]="'accordion-panel-' + id"
    [id]="'accordion-header-' + id"
    (click)="toggle()">
    <div class="flex flex--middle u--1/1">
      <svg-icon
        name="ico-caret-down-16"
        class="accordion__chevron"
        [ngClass]="caretsOnRight ? 'accordion__chevron--right' : ''"
        *ngIf="!selected"
        [ngStyle]="{ height: '16px' }"
        [svgStyle]="{ 'width.px': '16', 'height.px': '16', fill: 'currentColor' }">
      </svg-icon>

      <svg-icon
        name="ico-caret-up-16"
        class="accordion__chevron"
        [ngClass]="caretsOnRight ? 'accordion__chevron--right' : ''"
        *ngIf="selected"
        [ngStyle]="{ height: '16px' }"
        [svgStyle]="{ 'width.px': '16', 'height.px': '16', fill: 'currentColor' }">
      </svg-icon>

      <svg-icon
        class="accordion__icon"
        *ngIf="icon"
        [name]="icon"
        [ngStyle]="{ height: '24px' }"
        [svgStyle]="{ 'width.px': '24', 'height.px': '24', fill: 'currentColor' }">
      </svg-icon>

      <div type="button" [id]="'accordion-label-' + id" class="accordion__trigger text-bold-16">
        <ng-container *ngIf="!(labelTemplate | isTemplateRef)"> {{ label }} </ng-container>
        <ng-container *ngIf="labelTemplate | isTemplateRef" [ngTemplateOutlet]="labelTemplate"></ng-container>
      </div>
      <div class="accordion__additional-text"> {{ additionalText }} </div>
    </div>
    <div *ngIf="secondaryHeadingLabel" class="accordion__secondary-heading" [ngClass]="[caretsOnRight ? 'accordion__secondary-heading--caret-on-right' : '']">
      <span>{{ secondaryHeadingLabel }}</span>
    </div>
  </button>
</dt>

<dd
  role="region"
  aria-hidden="true"
  class="accordion__panel"
  *ngIf="selected"
  [id]="'accordion-panel-' + id"
  [attr.aria-labelledby]="'accordion-label-' + id"
  [ngClass]="[selected ? 'accordion__panel--opened' : '', !!panelPadding ? ('accordion__panel--padding-'+ panelPadding) : '', caretsOnRight ? 'accordion__panel--caret-on-right' : '' ]">
  <ng-content></ng-content>
</dd>
